export default "__VITE_ASSET__c8935dde__"